'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames4 = require('classnames');

var _classnames5 = _interopRequireDefault(_classnames4);

var _util = require('./util');

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

var _datepickerLocal = require('./datepicker.local.css');

var _datepickerLocal2 = _interopRequireDefault(_datepickerLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var YearBar = function YearBar(_ref) {
  var _classnames, _classnames2;

  var quarter = _ref.quarter,
      year = _ref.year,
      setPeriod = _ref.setPeriod,
      hasPermissionForQuarter = _ref.hasPermissionForQuarter,
      hasPermissionForMonth = _ref.hasPermissionForMonth,
      selectedPeriod = _ref.selectedPeriod,
      hoveringPeriod = _ref.hoveringPeriod,
      className = _ref.className,
      isCurrentYear = _ref.isCurrentYear;
  var QUARTERS = _constants2.default.QUARTERS;
  var currentQuarter = QUARTERS[quarter];
  return _react2.default.createElement('div', {
    className: className
  }, _react2.default.createElement('button', {
    id: 'quarter' + quarter,
    'data-auto': 'quarter-toggle-q' + quarter,
    className: (0, _classnames5.default)(_datepickerLocal2.default.quarter, _datepickerLocal2.default.button, (_classnames = {}, _defineProperty(_classnames, _datepickerLocal2.default.active, (0, _util.isInPeriod)(selectedPeriod, {
      quarter: quarter,
      year: year
    })), _defineProperty(_classnames, _datepickerLocal2.default.hover, (0, _util.isInPeriod)(hoveringPeriod, {
      quarter: quarter,
      year: year
    })), _defineProperty(_classnames, _datepickerLocal2.default.startOfSixMonth, isCurrentYear && ((0, _util.quarterIsStartOfHalfYear)(selectedPeriod, quarter, year) || (0, _util.quarterIsStartOfHalfYear)(hoveringPeriod, quarter, year))), _defineProperty(_classnames, _datepickerLocal2.default.endOfSixMonth, isCurrentYear && ((0, _util.quarterIsEndOfHalfYear)(selectedPeriod, quarter, year) || (0, _util.quarterIsEndOfHalfYear)(hoveringPeriod, quarter, year))), _defineProperty(_classnames, _datepickerLocal2.default.sixMonthSandwich, isCurrentYear && ((0, _util.quarterIsStartOfHalfYear)(selectedPeriod, quarter, year) || (0, _util.quarterIsStartOfHalfYear)(hoveringPeriod, quarter, year)) && ((0, _util.quarterIsEndOfHalfYear)(selectedPeriod, quarter, year) || (0, _util.quarterIsEndOfHalfYear)(hoveringPeriod, quarter, year))), _classnames)),
    disabled: !hasPermissionForQuarter(quarter, year),
    onMouseEnter: function onMouseEnter() {
      return setPeriod('hovering', 'quarter', {
        quarter: quarter,
        year: year
      });
    },
    onMouseLeave: function onMouseLeave() {
      return setPeriod('hovering', '', {});
    },
    onClick: function onClick() {
      return setPeriod('selected', 'quarter', {
        quarter: quarter,
        year: year
      });
    }
  }, currentQuarter.label), _react2.default.createElement('div', {
    className: (0, _classnames5.default)(_datepickerLocal2.default.months, (_classnames2 = {}, _defineProperty(_classnames2, _datepickerLocal2.default.active, (0, _util.isInPeriod)(selectedPeriod, {
      quarter: quarter,
      year: year
    })), _defineProperty(_classnames2, _datepickerLocal2.default.hover, (0, _util.isInPeriod)(hoveringPeriod, {
      quarter: quarter,
      year: year
    })), _classnames2))
  }, currentQuarter.months.map(function (month, index) {
    var _classnames3;

    return _react2.default.createElement('button', {
      key: month.label,
      id: month.label,
      onMouseEnter: function onMouseEnter() {
        return setPeriod('hovering', 'month', {
          month: month.number,
          year: year
        });
      },
      onMouseLeave: function onMouseLeave() {
        return setPeriod('hovering', '', {});
      },
      onClick: function onClick() {
        return setPeriod('selected', 'month', {
          month: month.number,
          year: year
        });
      },
      className: (0, _classnames5.default)(_datepickerLocal2.default.button, (_classnames3 = {}, _defineProperty(_classnames3, _datepickerLocal2.default.leftMonth, index === 0), _defineProperty(_classnames3, _datepickerLocal2.default.rightMonth, index === 2), _defineProperty(_classnames3, _datepickerLocal2.default.active, (0, _util.isInPeriod)(selectedPeriod, {
        month: month.number,
        year: year
      })), _defineProperty(_classnames3, _datepickerLocal2.default.hover, (0, _util.isInPeriod)(hoveringPeriod, {
        month: month.number,
        year: year
      })), _classnames3)),
      disabled: !hasPermissionForMonth(month.number, year)
    }, month.label);
  })));
};

YearBar.propTypes = {
  quarter: _propTypes2.default.number.isRequired,
  year: _propTypes2.default.number.isRequired,
  selectedPeriod: _propTypes2.default.shape({
    type: _propTypes2.default.string,
    date: _propTypes2.default.string
  }).isRequired,
  hoveringPeriod: _propTypes2.default.shape({
    type: _propTypes2.default.string,
    date: _propTypes2.default.string
  }).isRequired,
  hasPermissionForQuarter: _propTypes2.default.func.isRequired,
  hasPermissionForMonth: _propTypes2.default.func.isRequired,
  setPeriod: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string,
  isCurrentYear: _propTypes2.default.bool
};
exports.default = YearBar;